import React, { useState } from "react"
import { useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Helmet } from "react-helmet"
// Components
import Navbar from "../../components/Navbar/Navbar"
import Footer from "../../components/Footer/Footer"
import Products from "../../components/Products/Products"
// Styled
import { Container, Title, Wrapper } from "./Search.styles"

const Search = () => {
   const { searchTerm } = useParams()
   const { t } = useTranslation()
   const [endingPoint, setEndingPoint] = useState({ top: 0, left: 0 })

   return (
      <>
         <Helmet>
            <title>{t("searchPage.meta.meta_title")}</title>
            <meta name="robots" content="noindex, nofollow" />
         </Helmet>
         <Container>
            <Navbar
               searched={searchTerm}
               getCartPosition
               setCartPosition={setEndingPoint}
               bgImageColor="light"
            />
            <Wrapper>
               <Title>
                  {t("searchPage.title.t1")} {searchTerm}
               </Title>
               <Products search={searchTerm} endingPoint={endingPoint} />
            </Wrapper>
            <Footer />
         </Container>
      </>
   )
}

export default Search
